import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@shared/lib/http/axiosBaseQuery";
import { Document, DocumentEdit } from "@models/document";

export const documentsApi = createApi({
  reducerPath: "documentsApi",
  baseQuery: axiosBaseQuery({ baseUrl: "/api/" }),
  tagTypes: ["Documents"],
  endpoints: (b) => ({
    SearchDocuments: b.query<Document[], Partial<Document>>({
      query: (filters) => ({
        url: "documents/search/id/10/ASC?load=documentSettings,documentAccount.customData,car.customData,works.customData,items.customData,payments,account",
        method: "POST",
        body: filters,
      }),
      providesTags: ["Documents"],
      keepUnusedDataFor: Infinity,
    }),

    getDocument: b.query<Document, number>({
      query: (documentId) => ({
        url: `documents/${documentId}?load=documentSettings,documentAccount.customData,car.customData,works.customData,items.customData,payments,deposits,closing`,
        method: "GET",
      }),
      providesTags: (_res, _err, documentId) => [{ type: "Documents", id: documentId }],
      keepUnusedDataFor: Infinity,
    }),

    editSystemTable: b.mutation<Document, DocumentEdit>({
      query: (documentToUpdate) => ({
        url: `documents/${documentToUpdate.id}`,
        method: "PATCH",
        body: documentToUpdate,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          documentsApi.util.updateQueryData("SearchDocuments", {}, (draft) => {
            const row = draft.find((t) => t.id === arg.id);
            if (row) Object.assign(row, arg);
          }),
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
      invalidatesTags: (_res, _err, arg) => [
        { type: "Documents" as const, id: arg.id },
        { type: "Documents" as const, id: "LIST" as const },
      ],
    }),
  }),
});

export const { useGetDocumentQuery } = documentsApi;
